function eventListeners() {
  [...document.querySelectorAll('textarea')].forEach(textarea => {
    textarea.addEventListener('input', auto_grow);
  });
}

function auto_grow(event) {
  event.target.style.height = "5px";
  event.target.style.height = (event.target.scrollHeight)+"px";
}

function watchTextInputs() {
  const inputs = document.querySelectorAll(
    'input[type="text"], input[type="email"], input[type="number"], input[type="password"], input[type="search"], input[type="tel"], textarea'
  );

  [...inputs].forEach(input => {
    input.addEventListener('change', evt => {
      input.value.length
        ? input.classList.add('has-value')
        : input.classList.remove('has-value');
    });
  });

  window.addEventListener('clearinput', evt => {
    const input = document.getElementById(evt.detail);

    if (input) {
      input.value = '';
      input.classList.remove('has-value');
      input.focus();
    }
  });
}

export function init() {
  eventListeners();
  watchTextInputs();
}